import { lighten } from 'polished';

export function getColor(color: string | undefined) {
  if (color) {
    return lighten(color.startsWith('hsl') ? 0.35 : 0.45, color);
  }
  return undefined;
}
